import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import ROUTE_PATHS from "./utils/routePaths";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./utils/theme";
import WelcomeScreen from "./screens/Welcome Screen/WelcomeScreen";
import SigninScreen from "./screens/Signin Screen/SigninScreen";
import InitialLoadScreen from "./screens/Initial Load Screen/InitialLoadScreen";
import WorkspaceDetailScreen from "screens/Workspace Detail Screen/WorkspaceDetailScreen";
import MeetingRoomListScreen from "screens/Meeting Room List Screen/MeetingRoomListScreen";
import { TabBarProvider } from "services/TabBarProvider";
import HomeScreen from "screens/Home Screen/HomeScreen";
import CreditPlanDetailScreen from "screens/Membership Screen/Credit Plan Detail Screen/CreditPlanDetailScreen";
import OneDayPassDetailScreen from "screens/Membership Screen/One Day Pass Detail Screen/OneDayPassDetailScreen";
import MembershipPlanDetailScreen from "screens/Membership Screen/Membership Plan Detail Screen/MembershipPlanDetailScreen";
import URMembershipPlanDetailScreen from "screens/Membership Screen/UR Membership Plan Detail Screen/URMembershipPlanDetailScreen";
import MembershipPaymentDetailScreen from "screens/Membership Screen/Membership Payment Detail Screen/MembershipPaymentDetailScreen";
import CalendarPaymentScreen from "screens/Calendar Payment Screen/CalendarPaymentScreen";
import DFWorkspaceDetailScreen from "screens/Calendar Detail Screens/DF Workspace Detail Screen/DFWorkspaceDetailScreen";
import EventDetailScreen from "screens/Calendar Detail Screens/Event Detail Screen/EventDetailScreen";
import MBStudioDetailScreen from "screens/Calendar Detail Screens/MB Studio Detail Screen/MBStudioDetailScreen";
import ProfileSetupScreen from "screens/Profile Setup Screen/ProfileSetupScreen";
import CommunicateSpaceDetailScreen from "screens/Calendar Detail Screens/Communicate Space Detail Screen/CommunicateSpaceDetailScreen";
import FAQDetailScreen from "screens/FAQ Detail Screen/FAQDetailScreen";
import WebLinkDetailScreen from "screens/Web Link Detail Screen/WebLinkDetailScreen";
import AllSetScreen from "screens/Membership Screen/All Set Screen/AllSetScreen";
import RetreatDetailScreen from "screens/Retreat Detail Screen/RetreatDetailScreen";
import ReservationCancelSuccessScreen from "screens/Reservation Cancel Success Screen/ReservationCancelSuccessScreen";
import PaymentHistoryScreen from "screens/Payment History Screen/PaymentHistoryScreen";
import PaymentHistoryDetailScreen from "screens/Payment History Screen/Payment History Detail Screen/PaymentHistoryDetailScreen";
import InnovativeSpaceDetailScreen from "screens/Calendar Detail Screens/Innovative Space Detail Screen/InnovativeSpaceDetailScreen";
import CreativeSpaceDetailScreen from "screens/Calendar Detail Screens/Creative Space Detail Screen/CreativeSpaceDetailScreen";
import KeysDetailScreen from "screens/Keys Detail Screen/KeysDetailScreen";
import usePageTracking from "services/usePageTracking";
import useSessionTimeout from "services/useSessionTimeout";

const AppRoutes = () => {
  usePageTracking();
  useSessionTimeout();

  return (
    <Routes>
      <Route path={ROUTE_PATHS.HOME} element={<WelcomeScreen />} />
      <Route path={ROUTE_PATHS.WSM_SIGNIN} element={<SigninScreen />} />
      <Route
        path={ROUTE_PATHS.WSM_INITIAL_LOAD}
        element={<InitialLoadScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_PROFILE_SETUP}
        element={<ProfileSetupScreen />}
      />
      <Route path={ROUTE_PATHS.WSM_FAQ} element={<FAQDetailScreen />} />
      <Route path={ROUTE_PATHS.WSM_KEYS} element={<KeysDetailScreen />} />
      <Route path={ROUTE_PATHS.WSM_HOME} element={<HomeScreen />} />
      <Route
        path={ROUTE_PATHS.WSM_WORKSPACE_DETAIL}
        element={<WorkspaceDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_RETREAT_DETAIL}
        element={<RetreatDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_MEETING_ROOM_LIST}
        element={<MeetingRoomListScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_PAYMENT}
        element={<CalendarPaymentScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_DF_WORKSPACE_DETAIL}
        element={<DFWorkspaceDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_INNOVATIVE_SPACE}
        element={<InnovativeSpaceDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_CREATIVE_SPACE}
        element={<CreativeSpaceDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_EVENT_DETAIL}
        element={<EventDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_MB_STUDIO_DETAIL}
        element={<MBStudioDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_CALENDAR_COMMUNICATE_SPACE_DETAIL}
        element={<CommunicateSpaceDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL}
        element={<MembershipPlanDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL}
        element={<URMembershipPlanDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_MEMBERSHIP_PAYMENT_DETAIL}
        element={<MembershipPaymentDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_MEMBERSHIP_CREDIT_PLAN_DETAIL}
        element={<CreditPlanDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_MEMBERSHIP_ONE_DAY_PASS_DETAIL}
        element={<OneDayPassDetailScreen />}
      />
      <Route path={ROUTE_PATHS.WSM_ALL_SET} element={<AllSetScreen />} />
      <Route
        path={ROUTE_PATHS.WSM_WEB_LINK_DETAIL}
        element={<WebLinkDetailScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_RESERVATION_CANCEL}
        element={<ReservationCancelSuccessScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_PAYMENT_HISTORY}
        element={<PaymentHistoryScreen />}
      />
      <Route
        path={ROUTE_PATHS.WSM_PAYMENT_HISTORY_DETAIL}
        element={<PaymentHistoryDetailScreen />}
      />
    </Routes>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TabBarProvider>
        <Router>
          <AppRoutes />
        </Router>
      </TabBarProvider>
    </ThemeProvider>
  );
};

export default App;
